import { ReactElement, useState } from 'react';
import { NavigatorTab, Sort, useInfiniteScroll } from '@components/common';
import { UserListFilterTag, UserListFilters, UserListSearch, UsersTab, BDESEUsersTab } from '.';
import { overlayAddFadeAction, overlayRemoveFadeAction } from '@components/common/sort';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { UserListCard } from '@components/lms/userList/components/userListCard/userListCard';
import { useLmsUserLeadsRxDb } from '@services/hooks/lms/userLeads/useLmsUserLeadsRxDb';
import { useLmsUserListFilterStore, LmsUserListFilterStore } from '@store/lms/userListFilterStore';
import { useFilterStore } from '@store/filter';
import { useComponentLevelAccessCheck } from '../../../authGuard/hooks/useComponentLevelAccessCheck';
import { useLocation } from 'react-router-dom';
import { useCloseLeadsPopup } from '@store/closeLeadsPopupStore';
import { CloseLeadsModal } from '@components/common/close-leads/closeLeadsPopUp';
import { Modal } from '@components/common/modal/modal';
import { useSetMainHeader } from '@hooks/useSetMainHeader';

export const UserList = (): ReactElement => {
	const location = useLocation();
	const { isOpen, setModal, setTitle } = useCloseLeadsPopup((state) => state);

	const { lmsUserListFilter } = useLmsUserListFilterStore() as LmsUserListFilterStore;
	const { search, sortValue } = useFilterStore();
	const [openSort, setOpenSort] = useState<boolean>(false);
	const [openFilter, setOpenFilter] = useState<boolean>(false);
	const isNewLead = location.pathname === '/lms/new-leads' ? true : false;

	// inside UserList component

	const getHeaderText = (): string => {
		switch (location.pathname) {
			case '/lms/new-leads':
				return ' End Users';
			case '/lms/user-list':
				return 'All End Users';
			default:
				return 'End Users';
		}
	};
	useSetMainHeader(getHeaderText());

	const checkNewLeadPermissions = useComponentLevelAccessCheck('newleads');
	const { result, fetchMore, totalCount } = useLmsUserLeadsRxDb({
		searchValue: search,
		sortBy: sortValue,
		createddate: lmsUserListFilter.createddate,
		status: isNewLead ? 'Pending' : lmsUserListFilter.status,
		competition_tag: lmsUserListFilter.competition_tag,
		source: lmsUserListFilter.source,
		rigidGluePotential: lmsUserListFilter.rigidGluePotential,
		referral_source_c: lmsUserListFilter.referral_source_c,
	});
	useInfiniteScroll(() => {
		fetchMore();
	});
	return (
		<>
			<section className="user-list-section tab-search-section">
				<div className="container">
					<NavigatorTab
						tabList={checkNewLeadPermissions ? BDESEUsersTab : UsersTab}
						selectedFilterChild={<UserListFilterTag count={totalCount} />}
					>
						<UserListSearch
							setSortCallback={() => setOpenSort(true)}
							setFilterCallback={() => overlayAddFadeAction(() => setOpenFilter(true))}
						/>
					</NavigatorTab>

					<div className="common-list-card user-list-card common-user-list-card">
						<ul className="row">
							{result && result.length !== 0 ? (
								result.map((user) => (
									<UserListCard key={user._data.id} data={user._data} isHideButton={checkNewLeadPermissions} />
								))
							) : (
								<NoDataFound />
							)}
						</ul>
					</div>
				</div>
			</section>
			{openSort && <Sort setSortOpen={() => overlayRemoveFadeAction(() => setOpenSort(false))} />}
			{openFilter && (
				<UserListFilters
					openFilters={openFilter}
					closeFilters={() => overlayRemoveFadeAction(() => setOpenFilter(false))}
					hideFilters={isNewLead ? true : false}
					hideLeadByFilter={checkNewLeadPermissions ? false : true}
				/>
			)}
			<Modal
				modalOpen={isOpen}
				modalId={'closeLeads'}
				onModalClose={() => {
					setModal(false);
					setTitle('Please select a reason for closure of lead');
				}}
				className="dialog-sm close-site-popup dialog-conform"
			>
				<CloseLeadsModal />
			</Modal>
		</>
	);
};
